import React from "react";
import { useForm } from "react-hook-form";
import { customClasses } from "../../../Styles/customClasses";

import { useAppContext } from "../../../Store/store";

import CheckIcon from "@material-ui/icons/Check";
import TickPoints from "../../../Components/TickPoints";
import mkiLegalTeam from "../../../Assets/mkilegalteam.png";
import { Button } from "../../../Components/Basic";
const dataArray = [
  "Our legal team will represent you.",
  "Court documents prepared & filed.",
  "Communicating with your spouse.",
  "Pay over 4 months options available.",
];

function Estimate({ onSubmit, store }) {
  const { contextState, setContextState } = useAppContext();

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: store,
  });

  return (
    <form id="divorce-form" onSubmit={handleSubmit(onSubmit)}>
      <section className="mx-auto w-5/6 md:w-2/3 lg:w-1/2 xl:w-1/2  p-10 mt-10 shadow-lg">
        {contextState?.data?.priceData?.contactSupport ? (
          /* If spouse cannot be located */
          <section className="bg-red-300 rounded h-30 relative	">
            <p className="text-black text-center text-3xl pt-2 px-5">
              We Can't Give An Online Estimate
            </p>
            <p className="text-black mt-2 pb-5	text-center px-5">
              As you do not know where your spouse is, we cannot give you an
              estimate online. Please contact our team so we can advise you of
              the costs.
            </p>
          </section>
        ) : (
          /* If spouse can be located */
          <section className="bg-nativeBlue-100 rounded h-30 relative	">
            <p className="text-black text-center pt-2">Estimated Legal Fees</p>
            <p className="text-black font-bold text-4xl mt-2	text-center">
              ${contextState?.data?.priceData?.basePrice.toLocaleString()}
            </p>
            <p className="text-gray-500  text-center text-xs	mt-2 pb-5">
              including GST
            </p>
          </section>
        )}

        {contextState?.data?.priceData?.contactSupport === true ? null : (
          <section>
            <p className="text-gray-500 italic text-sm mt-5	">
              Plus these additional costs:
            </p>

            <table class="table-auto mt-5 ">
              {/* */}
              <tr>
                <td className="pb-5">
                  <p className="font-bold pb-2 ">Court Filing Fee </p>
                  <p className="text-xs text-gray-500">
                    This is the fee that needs to be paid to the Court to lodge
                    your divorce application. There is a possibility to get a
                    reduced fee if you have a concession card.
                  </p>
                </td>
                <td className="pl-4 pt-5 ">
                  $940{" "}
                  <p className="text-xs italic text-gray-500">
                    {" "}
                    $310 if reduced
                  </p>
                </td>
              </tr>

              {/* Service Fee */}
              {contextState?.data?.priceData?.serviceFee ===
              "notRequired" ? null : (
                <tr>
                  <td className="pb-5">
                    <p className="pb-2 ">
                      {" "}
                      <span className="font-bold"> Process Server Fee</span>
                      <span> (If Required) </span>
                    </p>
                    <p className="text-xs text-gray-500">
                      This is only required if your spouse does not sign and
                      return a document acknowledging they received your court
                      documents. A process server is a professional who hands
                      the court documents to your spouse by hand. The fee is
                      dependent on where your spouse lives. We will provide a
                      more accurate cost beforehand.
                    </p>
                  </td>

                  {contextState?.data?.priceData?.serviceFee === "localFee" && (
                    <td className="pl-4 pt-5 ">
                      $110
                      <p className="pt-2 italic text-xs text-gray-500">
                        Estimate for metro area
                      </p>
                    </td>
                  )}

                  {contextState?.data?.priceData?.serviceFee ===
                    "contactUs" && (
                    <td className="pl-4 pt-5 ">
                      <p className="pt-2 italic text-xs text-gray-500">
                        Contact Us For Estimate As Your Spouse is Overseas
                      </p>
                    </td>
                  )}

                  {contextState?.data?.priceData?.serviceFee === "unsure" && (
                    <td className="pl-4 pt-5 ">
                      <p className="pt-2 italic text-xs text-gray-500">
                        Contact Us For Estimate As Your Spouse May Be Overseas
                      </p>
                    </td>
                  )}
                </tr>
              )}

              {/* Marriage Certificate*/}
              {contextState?.data?.priceData?.marriageGetCertificate ===
              false ? null : (
                <tr>
                  <td className="pb-5">
                    <p className="font-bold pb-2 ">Marriage Certificate</p>
                    {/* If  Australia */}
                    <p className="text-xs text-gray-500">
                      We will need to order a copy of your marriage certificate
                      from the Registry.
                    </p>
                    {/* If Overseas */}
                    <p className="text-xs text-gray-500">
                      As you are married overseas, the marriage certificate will
                      need to be obtained from the overseas registry. It is not
                      possible for us to provide a cost for this. If you cannot
                      obtain it, there is a process to apply for an exemption.
                    </p>
                  </td>

                  {contextState?.data?.priceData?.marriageGetCertificate ===
                  "contactUs" ? (
                    <td className="pl-4 pt-5 ">
                      <p className="text-xs text-gray-500">
                        Contact Us To Discuss
                      </p>
                    </td>
                  ) : (
                    <td className="pl-4 pt-5 ">
                      <p>
                        ${contextState?.data?.priceData?.marriageGetCertificate}
                      </p>
                    </td>
                  )}
                </tr>
              )}

              {/*  Translation of Certificate */}

              {contextState?.data?.priceData?.marriageGetTranslation ===
              true ? (
                <tr>
                  <td className="pb-5 ">
                    <p className="font-bold pb-2 ">
                      Translation Of Marriage Certificate
                    </p>
                    <p className="text-xs text-gray-500">
                      If your marriage certificate is not in English, we will
                      need to get it translated by a professional translator.
                    </p>
                  </td>
                  <td className="pl-4 pt-5 ">
                    $300-$400{" "}
                    <p className="text-xs italic text-gray-500"> Estimate</p>
                  </td>
                </tr>
              ) : null}

              {/* Counselling Certificate */}

              {contextState?.data?.priceData?.counselCertRequired === true ? (
                <tr>
                  <td className="pb-5 ">
                    <p className="font-bold pb-2 ">Counselling Certificate</p>
                    <p className="text-xs text-gray-500">
                      You will need to obtain a counselling certificate because
                      your marriage occurred less than 2 years ago. We will
                      guide you through this process. Don’t worry you don’t need
                      to get back together with your spouse. You just need to
                      explain the relationship is over for good.
                    </p>
                  </td>
                  <td className="pl-4 pt-5 ">Nominal</td>
                </tr>
              ) : null}
            </table>

            {/* The features selling points */}
            <div>
              <TickPoints dataArray={dataArray} />
            </div>

            <div>
              <p className="text-3xl font-bold text-center mt-10">
                Get Started
              </p>
              <p className="text-center mt-5">
                Get in touch if you have any questions or if you are interested
                in getting started.
              </p>
              <p className="text-center mt-5">
                Free no-obligation discussion about your divorce.
              </p>
              <div className="flex ">
                {/* <div className="flex-1  px-5 ">
                  <a href="tel:+61894702777">
                    <Button
                      fontSize="lg"
                      form="divorce-form"
                      className="mt-5 w-full focus:outline-none p-4 border-nativeOrange-200  hover:bg-yellow-500  hover:border-yellow-500"
                    >
                      <p className="text-black">Call Us (08) 9470 2777</p>
                    </Button>
                  </a>
                </div> */}
                <div className="flex-1 px-10 md:px-20 ">
                  <Button
                    type="submit"
                    fontSize="lg"
                    form="divorce-form"
                    className=" mt-5 w-full focus:outline-none p-4 bg-nativeOrange-200 hover:bg-yellow-500  hover:border-yellow-500"
                  >
                    Get Started
                  </Button>
                </div>
              </div>
              <img className="mt-10" src={mkiLegalTeam} />
            </div>
          </section>
        )}
      </section>
    </form>
  );
}

export default Estimate;
